// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M1rwT","buttons":"styles_buttons__2fXpI"};